const Card = ({
  icon,
  title,
  description,
  isImageCard,
  isBlock,
  personName,
  position,
  isTeam,
}) => {
  if (isBlock) {
    return (
      <div className="block-card">
        <div className="inline-icon">
          {icon} <p className="card-title d-inline">{title}</p>
        </div>
        <p
          dangerouslySetInnerHTML={{ __html: description }}
          className="card-block-description"
        ></p>
      </div>
    );
  }

  if (isTeam && isImageCard) {
    return (
      <div style={{ padding: '20px' }} className="card">
        <div className="card-image">{icon}</div>
        <p className="card-description">{description}</p>
        <div>
          <h2 style={{ marginBottom: '-10px' }} className="card-title">
            {personName}
          </h2>
          <p
            style={{ marginTop: '-10px', fontSize: '0.8em' }}
            className="card-description"
          >
            {position}
          </p>
        </div>
      </div>
    );
  }

  return isImageCard ? (
    <div style={{ padding: '20px' }} className="card">
      <div className="card-image">{icon}</div>
      <p className="card-description">{description}</p>
      <div>
        <h2
          style={{ marginBottom: '-10px', marginTop: '20px' }}
          className="card-title"
        >
          {personName}
        </h2>
        <p
          style={{ marginTop: '-10px', fontSize: '0.8em' }}
          className="card-description"
        >
          {position}
        </p>
      </div>
    </div>
  ) : (
    <div className="card">
      <div className="card-icon">{icon}</div>
      <h2 className="card-title">{title}</h2>
      <p
        dangerouslySetInnerHTML={{ __html: description }}
        className="card-description"
      ></p>
    </div>
  );
};

export default Card;
